//Call_[npm_run_updateIndexes]_to_update_this_file.

// @create-index

import _role from './role';
export const role = _role;
export default {role};

